<template>
  <div>
    <div class="vendor-form">
      <div class="vendor-form-label">Negara</div>
      <div class="vendor-input">
        <v-select class="style-chooser" placeholder="Pilih Negara" label="negara" :options="countries"
          v-model="choosed_country" autocomplete="negara" :disabled="disabled" />
      </div>
    </div>
    <div class="vendor-form" v-if="choosed_country && choosed_country.id == 63">
      <div class="vendor-form-label">
        Provinsi
      </div>
      <div class="vendor-input">
        <v-select class="style-chooser" placeholder="Pilih Provinsi" label="desc" :options="provinces"
          v-model="choosed_province" :disabled="disabled" />
      </div>
    </div>
    <div class="vendor-form" v-if="choosed_province">
      <div class="vendor-form-label">Kota</div>
      <div class="vendor-input">
        <v-select class="style-chooser" placeholder="Pilih Kota" label="desc" :options="cities" v-model="choosed_city"
          autocomplete="kota" :disabled="disabled" />
      </div>
    </div>
    <div class="vendor-form" v-if="choosed_city">
      <div class="vendor-form-label">
        Kecamatan
      </div>
      <div class="vendor-input">
        <v-select class="style-chooser" placeholder="Pilih Kecamatan" label="desc" :options="districs"
          v-model="choosed_distric" :disabled="disabled" />
      </div>
    </div>
    <div class="vendor-form" v-if="choosed_distric">
      <div class="vendor-form-label">
        Kelurahan
      </div>
      <div class="vendor-input">
        <v-select class="style-chooser" placeholder="Pilih Kelurahan" label="desc" :options="villages"
          v-model="choosed_village" :disabled="disabled" />
      </div>
    </div>
    <div class="vendor-form">
      <p class="vendor-form-label">Kode Pos</p>
      <the-mask class="vendor-input" :mask="['######']" placeholder="Isikan kodepos" v-model="kodepos"
        :disabled="disabled" />
    </div>
  </div>
</template>
<script>
import { api } from '@/services/config'
import axios from 'axios'
export default {
  props: ['mutationName', 'storeName', 'disabled'],
  data() {
    return {
      countries: [],
      provinces: [],
      cities: [],
      districs: [],
      villages: [],
    }
  },
  created() {
    this.getCountry()
    this.getProvince()
  },
  computed: {
    provinsiAsing: {
      get() {
        return this.$store.state[this.storeName].provinsiAsing
      },
      set(newValue) {
        this.$store.commit(this.mutationName, {
          name: 'provinsiAsing',
          value: newValue,
        })
      },
    },
    kotaAsing: {
      get() {
        return this.$store.state[this.storeName].kotaAsing
      },
      set(newValue) {
        this.$store.commit(this.mutationName, {
          name: 'kotaAsing',
          value: newValue,
        })
      },
    },
    choosed_country: {
      get() {
        return this.$store.state[this.storeName].choosed_country
      },
      set(newValue) {
        this.$store.commit(this.mutationName, {
          name: 'choosed_country',
          value: newValue,
        })

        if (newValue) {
          if (newValue.id == 63) {
            this.$store.commit(this.mutationName, {
              name: 'k3l_pic_phone_code',
              value: '+62',
            })
          }
        } else {
          this.$store.commit(this.mutationName, {
            name: 'choosed_province',
            value: null,
          })
          this.$store.commit(this.mutationName, {
            name: 'choosed_city',
            value: null,
          })
          this.$store.commit(this.mutationName, {
            name: 'choosed_distric',
            value: null,
          })
          this.$store.commit(this.mutationName, {
            name: 'choosed_village',
            value: null,
          })
          this.$store.commit(this.mutationName, {
            name: 'kodepos',
            value: '',
          })
          this.$store.commit(this.mutationName, {
            name: 'phoneCode',
            value: '',
          })
        }
      },
    },
    choosed_province: {
      get() {
        return this.$store.state[this.storeName].choosed_province
      },
      set(newValue) {
        this.$store.commit(this.mutationName, {
          name: 'choosed_province',
          value: newValue,
        })
      },
    },
    choosed_city: {
      get() {
        if (
          this.$get(this.$store, `state.${this.storeName}.choosed_province.id`)
        ) {
          this.getCity()
        }
        return this.$store.state[this.storeName].choosed_city
      },
      set(newValue) {
        this.$store.commit(this.mutationName, {
          name: 'choosed_city',
          value: newValue,
        })
      },
    },
    choosed_distric: {
      get() {
        if (this.$get(this.$store, `state.${this.storeName}.choosed_city.id`)) {
          this.getDistric()
        }
        return this.$store.state[this.storeName].choosed_distric
      },
      set(newValue) {
        this.$store.commit(this.mutationName, {
          name: 'choosed_distric',
          value: newValue,
        })
      },
    },
    choosed_village: {
      get() {
        if (
          this.$get(this.$store, `state.${this.storeName}.choosed_distric.id`)
        ) {
          this.getVillage()
        }
        return this.$store.state[this.storeName].choosed_village
      },
      set(newValue) {
        this.$store.commit(this.mutationName, {
          name: 'choosed_village',
          value: newValue,
        })
        this.$store.commit(this.mutationName, {
          name: 'kodepos',
          value: newValue ? newValue.kodepos : '',
        })
      },
    },
    kodepos: {
      get() {
        return this.$store.state[this.storeName].kodepos
      },
      set: function (newValue) {
        this.$store.commit(this.mutationName, {
          name: 'kodepos',
          value: newValue,
        })
      },
    },
    phoneCode: {
      get() {
        return this.$store.state[this.storeName].phoneCode
      },
      set: function (newValue) {
        this.$store.commit(this.mutationName, {
          name: 'phoneCode',
          value: newValue,
        })
      },
    },
    phoneNumber: {
      get() {
        return this.$store.state[this.storeName].phoneNumber
      },
      set: function (newValue) {
        // let input = newValue
        // input = input.replace(/[\W\s\._\-]+/g, '')

        // let split = 0
        // let chunk = []

        // for (let i = 0; i < input.length; i += split) {
        //   split = i < 3 ? 3 : i < 5 ? 4 : 5
        //   chunk.push(input.substr(i, split))
        // }

        // let newPhoneNumber = chunk.join(' ')
        this.$store.commit(this.mutationName, {
          name: 'phoneNumber',
          value: newValue,
        })
      },
    },
    emailPerusahaan: {
      get: function () {
        return this.$store.state[this.storeName].emailPerusahaan
      },
      set: function (newValue) {
        this.$store.commit(this.mutationName, {
          name: 'emailPerusahaan',
          value: newValue,
        })
      },
    },
    address: {
      get: function () {
        return this.$store.state[this.storeName].address
      },
      set: function (newValue) {
        this.$store.commit(this.mutationName, {
          name: 'address',
          value: newValue,
        })
      },
    },
  },
  watch: {
    choosed_country: function (newValue, oldValue) {
      if (newValue && newValue.id == 63) {
        this.provinsiAsing = null
        this.kotaAsing = null
        this.kodepos = null
      } else {
        this.kodepos = this.$store.state[this.storeName].kodepos
      }
    },
    choosed_province: function (newValue, oldValue) {
      if (newValue !== oldValue && newValue == null) {
        this.$store.commit(this.mutationName, {
          name: 'choosed_province',
          value: newValue,
        })
        this.$store.commit(this.mutationName, {
          name: 'choosed_city',
          value: null,
        })
        this.$store.commit(this.mutationName, {
          name: 'choosed_distric',
          value: null,
        })
        this.$store.commit(this.mutationName, {
          name: 'choosed_village',
          value: null,
        })
        this.$store.commit(this.mutationName, {
          name: 'kodepos',
          value: null,
        })
      } else {
        this.getCity()
      }
    },
    choosed_city: function (newValue, oldValue) {
      if (newValue !== oldValue && newValue == null) {
        this.$store.commit(this.mutationName, {
          name: 'choosed_city',
          value: newValue,
        })
        this.$store.commit(this.mutationName, {
          name: 'choosed_distric',
          value: null,
        })
        this.$store.commit(this.mutationName, {
          name: 'choosed_village',
          value: null,
        })
        this.$store.commit(this.mutationName, {
          name: 'kodepos',
          value: null,
        })
      } else {
        this.getDistric()
      }
    },
    choosed_distric: function (newValue, oldValue) {
      if (newValue !== oldValue && newValue == null) {
        this.$store.commit(this.mutationName, {
          name: 'choosed_distric',
          value: newValue,
        })
        this.$store.commit(this.mutationName, {
          name: 'choosed_village',
          value: null,
        })
        this.$store.commit(this.mutationName, {
          name: 'kodepos',
          value: null,
        })
      } else {
        this.getVillage()
      }
    },
    choosed_village: function (newValue, oldValue) {
      if (newValue !== oldValue && newValue == null) {
        this.$store.commit(this.mutationName, {
          name: 'kodepos',
          value: '',
        })
      }
    },
  },
  methods: {
    async getCountry() {
      const url = `${api}/api/v1/negara?page=1&limit=1000`
      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        this.countries = data.data
      } catch (error) { }
    },
    async getProvince() {
      const url = `${api}/api/v1/provinsi?page=1&limit=1000`
      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        this.provinces = data.data
      } catch (error) { }
    },
    async getCity() {
      const url = `${api}/api/v1/kota?page=1&limit=1000&provinsi=${this.$get(
        this.$store,
        `state.${this.storeName}.choosed_province.id`
      )}`
      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        this.cities = data.data
      } catch (error) { }
    },
    async getDistric() {
      const url = `${api}/api/v1/kecamatan?page=1&limit=10000&kota=${this.$get(
        this.$store,
        `state.${this.storeName}.choosed_city.id`
      )}`
      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        this.districs = data.data
      } catch (error) { }
    },
    async getVillage() {
      const url = `${api}/api/v1/kelurahan?page=1&limit=1000&kecamatan=${this.$get(
        this.$store,
        `state.${this.storeName}.choosed_distric.id`
      )}`
      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        this.villages = data.data
      } catch (error) { }
    },
  },
}
</script>
